import type { VoidFunctionComponent } from 'react';

import { VCS_APP_DISPLAY } from '../../../../../shared/vcs/githubApp/apps';
import Button from '../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button/button-constants';

import styles from './VcsInstallPanel.module.less';

type Props = {
  onInstall: () => void;
};

/**
 * The main panel before the app is installed: what installing fossabot buys, and the button
 * that starts the vcs-service install. It is replaced by the repository list once installed.
 */
export const VcsInstallPanel: VoidFunctionComponent<Props> = ({ onInstall }) => (
  <div className={styles.panel}>
    <img className={styles.logo} src={VCS_APP_DISPLAY.fossabot.logo} alt="" />
    <h1 className={styles.heading}>Install the fossabot app</h1>
    <p className={styles.copy}>
      Grant fossabot access to your GitHub repositories so it can open fix PRs and run breaking
      change analysis automatically — without leaving FOSSA.
    </p>
    <Button type={BUTTON_TYPE.PRIMARY} size={BUTTON_SIZE.MEDIUM} onClick={onInstall}>
      Install on GitHub
    </Button>
  </div>
);
